import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _templateObject;
var _excluded = ["name", "className", "color", "size"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import cx from "classnames";
import React from "react"; // import "./Icon.scss";

export function Icon(_ref) {
  var name = _ref.name,
    className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    size = _ref.size,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return jsx("span", _extends({
    className: cx("icon", className),
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        --icon-color: ", ";\n        --icon-size: ", ";\n        mask-image: ", ";\n      "])), color, size, name ? "url(\"/icons/".concat(name, ".svg\")") : "none")
  }, restProps));
}